// 定义静态路由，动态路由(后端接口返回)及处理在 `utils/routesFilter.js` 中

export default [
    {
        path: '/preview',
        component: () => import('views/modules/message/preview'),
        meta: {
            title: '预览',
        },
    },
    {
        path: '/static/product/edit/:appId',
        name: 'product-edit',
        component: () => import('views/modules/product/edit'),
        meta: {
            parent: '/product/list',
            icon: 'el-icon-document',
            title: '添加产品',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
            keepAlive: true,
        },
    },
    {

        path: '/design/app',
        name: 'design',
        component: () => import('views/modules/np/design'),
        meta: {
            title: '数据源',
        },
    },
    {

        path: '/design/form/app',
        name: 'designform',
        component: () => import('views/modules/np/form/app/index'),
        meta: {
            title: '表单数据源',
        },
    },
    {
        path: '/np/app/detail/:appId',
        component: () => import('views/modules/np/app/app-content-list/index.vue'),
        meta: {
            parent: '/product/list',
            icon: 'el-icon-document',
            title: '添加内容',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        }
    }, {
        path: '/aihelper',
        component: () => import('views/modules/aihelper/index.vue'),
        meta: {
            parent: '/product/list',
            icon: 'el-icon-document',
            title: '添加内容',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        }
    },
    {
        path: '/static/market/ai-landing-page',
        meta: {
            parent: '/market/smart-page/smart-page',
            title: '营销落地页',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
            keepAlive: true,
        },
        component: () => import('@@/views/market/aiLandingPage/index.vue'),
    },
];
